// src/components/Terms.js
import { useState, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";

const CONTENT = {
  ar: {
    docTitle: "الشروط والأحكام لمقدّمي الخدمة",
    subtitle: "تطبيق ترستفيكس — TrustFix",
    back: "العودة إلى الصفحة الرئيسية",
    footerNote:
      "للتواصل بخصوص هذه الشروط، يُرجى مراسلتنا عبر قنوات الدعم الرسمية داخل التطبيق.",
    intro: [
      "منصّة ترستفيكس (TrustFix) هي منصّة إلكترونية لخدمات الصيانة والخدمات المنزلية، تربط بين العملاء ومقدّمي الخدمة. ويُشار إليها فيما بعد بـ «المنصّة» أو «التطبيق» أو «ترستفيكس». ويُقصد بمصطلح «الشريك» أو «مقدّم الخدمة» كل شخص أو منشأة تقدّم خدمات الصيانة أو الخدمات المنزلية للعملاء من خلال المنصّة. ويُقصد بمصطلح «العميل» كل شخص يطلب خدمات الصيانة أو الخدمات المنزلية أو يستفيد منها من خلال المنصّة.",
      "يُعدّ استخدام الشريك للتطبيق موافقةً صريحةً دون قيدٍ أو شرطٍ على هذه الشروط والأحكام، وإقراراً بفهمها. وفي حال عدم الموافقة، يتعيّن عليه التوقّف عن استخدام التطبيق فوراً.",
    ],
    sections: [
      {
        heading: "البند (1): طبيعة الخدمة وآلية عملها",
        list: [
          "تتيح المنصّة للعملاء طلب خدمات الصيانة والخدمات المنزلية، وتعرض الطلب على أقرب مقدّمي الخدمة المتاحين وفق نظام الإسناد الفوري.",
          "يُعرض الطلب في وقتٍ واحدٍ على عددٍ من أقرب مقدّمي الخدمة، ويكون القبول لأول من يقبله خلال المدة المحددة، ويتم توسيع نطاق البحث تلقائياً عند عدم القبول.",
          "تعمل المنصّة بصفتها وسيطاً تقنياً يربط بين العميل ومقدّم الخدمة، ولا تُعدّ طرفاً في العقد الفعلي بينهما.",
          "تحتفظ ترستفيكس بحقّ تعديل أيّ بندٍ من هذه الشروط دون إخطارٍ مسبق، ويُعدّ استمرار الشريك في الاستخدام قبولاً للشروط المحدّثة.",
        ],
      },
      {
        heading: "البند (2): الإقرارات والتعهّدات",
        list: [
          "أن يكون الشريك متمتّعاً بالأهلية الشرعية والنظامية الكاملة، وألا يوجد عليه سابقة قضائية مخلّة بالشرف أو الأمانة.",
          "أن يمتلك المؤهلات والتراخيص والخبرة اللازمة لتقديم الخدمات التي يعرضها، وأن يقدّمها بجودةٍ ومهنيةٍ عالية.",
          "أن الشريك طرفٌ مستقلٌّ ولا يعمل كوكيلٍ أو موظّفٍ أو شريكٍ ترستفيكس، ولا يجوز له تقديم نفسه كممثّلٍ للمنصّة.",
          "أن جميع البيانات والمستندات التي يقدّمها للمنصّة صحيحةٌ ودقيقةٌ ومحدّثة.",
        ],
      },
      {
        heading: "البند (3): التزامات مقدّم الخدمة",
        lead: "يلتزم الشريك بما يلي:",
        list: [
          "الامتثال لكافة الأنظمة واللوائح المعمول بها في المملكة العربية السعودية.",
          "تقديم الخدمة المطلوبة بأمانةٍ ومهنيةٍ وفي الوقت المتّفق عليه مع العميل.",
          "الحفاظ على سلامة ممتلكات العميل أثناء تقديم الخدمة، وتحمّل مسؤولية أيّ ضررٍ ينتج عن إهماله.",
          "المحافظة على اسم المستخدم وكلمة المرور بشكلٍ آمنٍ وسرّي، وعدم مشاركتها مع الغير.",
          "معاملة العملاء باحترامٍ، وعدم إيذاء أو مضايقة أيٍّ من مستخدمي المنصّة.",
          "عدم استخدام المنصّة لأغراضٍ غير مشروعة أو احتيالية.",
          "تحديث بياناته وموقعه الجغرافي بدقّةٍ أثناء تفعيل حالة الاستعداد لاستقبال الطلبات.",
        ],
      },
      {
        heading: "البند (4): آلية الدفع ورسوم المنصّة",
        list: [
          "يدفع الشريك رسم منصّةٍ ثابتاً عن كلّ طلبٍ يُسند إليه، ويُحصّل مقدّماً إلكترونياً عبر بوابة الدفع المعتمدة (Moyasar).",
          "يُتّفق على قيمة الخدمة الفعلية بين الشريك والعميل مباشرةً عند تقديم الخدمة، ولا تتدخّل المنصّة في تحديدها، ويحصّلها الشريك من العميل مباشرةً.",
          "يتحمّل الشريك وحده مسؤولية تحصيل قيمة خدمته من العميل، ولا تضمن ترستفيكس تحصيل هذه المبالغ.",
          "يجوز ترستفيكس تعديل قيمة رسم المنصّة، ويُعدّ استمرار الشريك بعد الإخطار موافقةً على الرسوم الجديدة.",
          "أيّ استرجاعٍ مالي لرسم المنصّة يتمّ إلى وسيلة الدفع الأصلية فقط، ولا يجوز تحويله إلى وسيلةٍ أخرى.",
          "يحظر على الشريك مطالبة العميل بأيّ مبالغ خارج نطاق الخدمة المتّفق عليها، أو التحصيل نيابةً عن الغير.",
        ],
      },
      {
        heading: "البند (5): سلوك الأمانة ومكافحة الاحتيال",
        list: [
          "يلتزم الشريك بالأمانة في جميع تعاملاته وفي بيانات العمليات المنفّذة.",
          "في حال اكتشاف أيّ تحايلٍ أو تلاعبٍ أو إساءةٍ في تقديم الخدمة، يحقّ ترستفيكس إيقاف الحساب وتحصيل غرامةٍ قدرها (1,000) ألف ريال سعودي، بالإضافة إلى المطالبة بالتعويض عن الأضرار.",
        ],
      },
      {
        heading: "البند (6): السلوكيات والخدمات المحظورة",
        lead: "يُحظر على الشريك القيام بأيٍّ من السلوكيات أو الخدمات الموضّحة أدناه:",
        prohibited: [
          ["العمل تحت تأثير مؤثّرٍ", "تقديم الخدمة تحت تأثير الكحول أو المخدرات أو أيّ مادةٍ تؤثّر على الأداء."],
          ["الأعمال غير المرخّصة", "تنفيذ أعمالٍ تتطلّب ترخيصاً أو تصريحاً لا يملكه الشريك (كهرباء، غاز، سباكة معتمدة)."],
          ["الخدمات غير القانونية", "أيّ خدمةٍ غير قانونيةٍ أو غير آمنةٍ أو احتيالية."],
          ["السلوك غير اللائق", "المضايقة أو الإساءة أو أيّ سلوكٍ غير لائقٍ تجاه العملاء."],
          ["الإضرار بالممتلكات", "الإهمال أو التسبّب في ضررٍ لممتلكات العميل أو مقرّ الخدمة."],
        ],
      },
      {
        heading: "البند (7): حقوق الملكية الفكرية",
        paras: [
          "جميع حقوق الملكية الفكرية في المنصّة وخدماتها وعلاماتها التجارية وتصميمها ومحتواها هي ملكٌ خالصٌ ترستفيكس. ولا يجوز للشريك إعادة إنتاجها أو استخدامها دون إذنٍ كتابيٍّ مسبق.",
        ],
      },
      {
        heading: "البند (8): حدود المسؤولية",
        list: [
          "تُقدَّم خدمات المنصّة «كما هي»، دون أيّ ضماناتٍ صريحةٍ أو ضمنيةٍ بشأن خلوّها من الأخطاء أو الانقطاع.",
          "تقع مسؤولية جودة الخدمة المقدّمة للعميل بالكامل على عاتق الشريك، ولا تتحمّل ترستفيكس مسؤولية أفعاله أو إهماله.",
          "لا تتحمّل المنصّة مسؤولية أيّ أضرارٍ تنشأ عن استخدام الشريك للتطبيق، ما لم تنتج عن إهمالٍ جسيمٍ من جانبها.",
          "أيّ نزاعٍ بين الشريك والعميل بشأن الخدمة يُعالَج بين الطرفين، وتكون المنصّة وسيطاً فقط.",
        ],
      },
      {
        heading: "البند (9): التعويض",
        paras: [
          "يوافق الشريك على تعويض ترستفيكس وإبراء ذمّتها من أيّ مطالباتٍ أو خسائرٍ أو أضرارٍ تنشأ عن مخالفته لهذه الشروط، أو انتهاكه لحقوق الغير، أو إساءة استخدامه للمنصّة.",
        ],
      },
      {
        heading: "البند (10): مدّة الاتفاقية وإنهاؤها",
        list: [
          "يحقّ للشريك إنهاء استخدام الخدمة في أيّ وقتٍ بحذف التطبيق من جهازه.",
          "يحقّ ترستفيكس إنهاء العلاقة التعاقدية فوراً ودون إشعارٍ مسبقٍ في حال إخلال الشريك بأيٍّ من هذه الشروط.",
        ],
      },
      {
        heading: "البند (11): القانون المطبّق وحلّ النزاعات",
        paras: [
          "تخضع هذه الشروط لأنظمة المملكة العربية السعودية. وفي حال نشوء نزاعٍ يتعذّر حلّه ودّياً خلال (30) ثلاثين يوماً، يُحال إلى المحاكم المختصّة في المملكة العربية السعودية.",
        ],
      },
    ],
  },
  en: {
    docTitle: "Service Provider Terms & Conditions",
    subtitle: "TrustFix",
    back: "Back to home",
    footerNote:
      "For questions about these Terms, please contact us through the official support channels in the app.",
    intro: [
      'TrustFix is an online platform for maintenance and home services that connects customers with service providers. It is subsequently referred to as the "platform," "application," or "TrustFix". "Partner" or "Service Provider" means any individual or business that offers maintenance or home services to customers through the platform. "Customer" means any person who requests or receives maintenance or home services through the platform.',
      "Using the app constitutes your express, unconditional acceptance of these Terms and your acknowledgement that you understand them. If you do not agree, you must stop using the app immediately.",
    ],
    sections: [
      {
        heading: "Clause 1: Nature of the Service",
        list: [
          "The platform lets customers request maintenance and home services, and offers each request to the nearest available providers using instant dispatch.",
          "A request is offered simultaneously to several nearby providers; the first to accept within the set window wins, and the search radius expands automatically if none accept.",
          "The platform acts only as a technical intermediary connecting customer and provider, and is not a party to the actual service contract between them.",
          "TrustFix may amend any of these Terms without prior notice; continued use after an update constitutes acceptance of the updated Terms.",
        ],
      },
      {
        heading: "Clause 2: Representations",
        list: [
          "The Partner has full legal capacity and no prior conviction involving dishonesty or breach of trust.",
          "The Partner holds the qualifications, licenses, and experience required for the services offered, and delivers them to a high professional standard.",
          "The Partner is an independent party and is not an agent, employee, or partner of TrustFix, and may not present themselves as a representative of the platform.",
          "All data and documents the Partner provides to the platform are true, accurate, and up to date.",
        ],
      },
      {
        heading: "Clause 3: Partner Obligations",
        lead: "The Partner agrees to:",
        list: [
          "Comply with all applicable laws and regulations in the Kingdom of Saudi Arabia.",
          "Deliver the requested service honestly, professionally, and at the agreed time.",
          "Protect the customer's property during the service and bear responsibility for any damage caused by negligence.",
          "Keep username and password secure and confidential and not share them with others.",
          "Treat customers respectfully and not harm or harass any platform user.",
          "Not use the platform for unlawful or fraudulent purposes.",
          "Keep location and availability accurate while active to receive requests.",
        ],
      },
      {
        heading: "Clause 4: Payment & Platform Fee",
        list: [
          "The Partner pays a fixed platform fee for each assigned request, charged upfront electronically via the approved payment gateway (Moyasar).",
          "The actual service price is agreed directly between Partner and customer at the time of service; the platform does not set it, and the Partner collects it directly from the customer.",
          "The Partner is solely responsible for collecting the service price from the customer; TrustFix does not guarantee collection.",
          "TrustFix may adjust the platform fee; continued use after notice constitutes acceptance of the new fee.",
          "Any refund of the platform fee is made only to the original payment method and may not be transferred elsewhere.",
          "The Partner may not demand any amount from the customer outside the agreed service, nor collect on behalf of third parties.",
        ],
      },
      {
        heading: "Clause 5: Integrity & Anti-Fraud",
        list: [
          "The Partner agrees to act honestly in all dealings and in the data of completed jobs.",
          "If any fraud, manipulation, or service abuse is detected, TrustFix may suspend the account and charge a misuse penalty of SAR 1,000, in addition to claiming compensation for damages.",
        ],
      },
      {
        heading: "Clause 6: Prohibited Conduct & Services",
        lead: "The Partner is prohibited from any of the conduct or services listed below:",
        prohibited: [
          ["Working while impaired", "Providing service under the influence of alcohol, drugs, or any substance affecting performance."],
          ["Unlicensed work", "Performing work requiring a license or permit the Partner does not hold (electrical, gas, certified plumbing)."],
          ["Illegal services", "Any unlawful, unsafe, or fraudulent service."],
          ["Inappropriate conduct", "Harassment, abuse, or any inappropriate behavior toward customers."],
          ["Property damage", "Negligence or causing damage to the customer's property or premises."],
        ],
      },
      {
        heading: "Clause 7: Intellectual Property",
        paras: [
          "All intellectual property rights in the platform, its services, trademarks, design, and content belong exclusively to TrustFix. The Partner may not reproduce or use them without prior written permission.",
        ],
      },
      {
        heading: "Clause 8: Limitation of Liability",
        list: [
          'Platform services are provided "as is," without any express or implied warranty of being error-free or uninterrupted.',
          "Responsibility for the quality of the service provided rests entirely with the Partner; TrustFix is not liable for the Partner's acts or negligence.",
          "The platform is not liable for damages arising from the Partner's use of the app, unless caused by its gross negligence.",
          "Any dispute between Partner and customer over the service is resolved between them; the platform acts only as an intermediary.",
        ],
      },
      {
        heading: "Clause 9: Indemnification",
        paras: [
          "The Partner agrees to indemnify and hold TrustFix harmless from any claims, losses, or damages arising from breach of these Terms, infringement of third-party rights, or misuse of the platform.",
        ],
      },
      {
        heading: "Clause 10: Term & Termination",
        list: [
          "The Partner may stop using the service at any time by deleting the app.",
          "TrustFix may terminate the relationship immediately and without prior notice if the Partner breaches any of these Terms.",
        ],
      },
      {
        heading: "Clause 11: Governing Law & Disputes",
        paras: [
          "These Terms are governed by the laws of the Kingdom of Saudi Arabia. Any dispute not resolved amicably within thirty (30) days is referred to the competent courts in the Kingdom of Saudi Arabia.",
        ],
      },
    ],
  },
};

export default function Terms() {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("tf_lang") || "ar";
    } catch {
      return "ar";
    }
  });

  const isAr = lang === "ar";
  const t = CONTENT[lang];

  useEffect(() => {
    try {
      localStorage.setItem("tf_lang", lang);
    } catch {}
  }, [lang]);

  return (
    <div className="min-h-screen bg-gray-50">
        <Header lang={lang} setLang={setLang} />
        <div className="min-h-screen bg-gray-150" dir={isAr ? "rtl" : "ltr"}>
            <section >
                <div className="max-w-4xl mx-auto px-5 pt-3 pb-3">
                  <h1 className="text-[26px] font-extrabold text-[#006C35] mt-2 mb-1">
                    {t.docTitle}
                  </h1>
                  <p className="text-gray-500 text-[15px] mt-0 mb-6">{t.subtitle}</p>
                </div>
            </section>
            <section className="bg-white">
              <div className="max-w-4xl mx-auto px-5 pt-8 pb-8">
                {t.intro.map((p, i) => (
                  <p key={i} className="text-gray-700 mb-3 leading-relaxed">
                    {p}
                  </p>
                ))}

                {t.sections.map((s) => (
                  <div key={s.heading}>
                    <h2 className="text-lg font-bold text-[#006C35] mt-6 mb-2">
                      {s.heading}
                    </h2>

                    {s.lead && <p className="text-gray-700 mb-3">{s.lead}</p>}

                    {s.paras &&
                      s.paras.map((p, i) => (
                        <p key={i} className="text-gray-700 mb-3 leading-relaxed">
                          {p}
                        </p>
                      ))}

                    {s.list && (
                      <ol
                        className={`list-decimal ${
                          isAr ? "pr-6" : "pl-6"
                        } mb-3 space-y-2 text-gray-700 leading-relaxed`}
                      >
                        {s.list.map((li, i) => (
                          <li key={i}>{li}</li>
                        ))}
                      </ol>
                    )}

                    {s.prohibited && (
                      <div className="mt-2.5 space-y-5">
                        {s.prohibited.map(([cat, ex]) => (
                          <div
                            key={cat}
                            className="bg-[#EDEEF2] border border-[#e2e4ec] rounded-xl px-3.5 py-3"
                          >
                            <div className="font-bold text-[#535C79] mb-1">{cat}</div>
                            <div className="text-gray-600 text-[14.5px]">{ex}</div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </section>
            <sections>
              <div className="max-w-4xl mx-auto px-5 pt-3 pb-8">
                <p className="text-gray-500 text-sm mt-5">{t.footerNote}</p>
              </div>
            </sections>
        </div>
        <Footer lang={lang} />
    </div>
  );
}